"use client";

import ToastContainerLazy from "@/contexts/ToastContainerLazy";
import { BlankContextProvider } from "@core/helpers/client/contexts/BlankContext";
import { InstallmentPaymentGatewaysContextProvider } from "@core/helpers/client/contexts/InstallmentPaymentGatewaysContext";
import { ProgressProvider } from "@bprogress/next/app";
import TracktorLoader from "@/components/TracktorLoader";
import MenusProvider from "@/contexts/MenusProvider";
import { LAYOUT_MENU_KEYS } from "@/helpers/menuKeys";

// initial_menus: منوهایی که root layout برای HTML سرور همین مسیر گرفته (helpers/layoutMenus.js)
const KernelContex = ({ children, initial_menus }) => {
  return (
    <>
      <TracktorLoader
        endpoint={"https://cdp.branchteam.ir"}
        pubKey={"pk299faa02e452b36f044086c1eb2908a2"}
      />
      <BlankContextProvider>
        <MenusProvider menuKeys={LAYOUT_MENU_KEYS} initial_menus={initial_menus}>
          <InstallmentPaymentGatewaysContextProvider>
            <ToastContainerLazy theme="light" />
            <ProgressProvider
              height="2px"
              color="#08535b"
              options={{ showSpinner: false }}
              shallowRouting
            />
            {children}
          </InstallmentPaymentGatewaysContextProvider>
        </MenusProvider>
      </BlankContextProvider>
    </>
  );
};

export default KernelContex;
